export const datePickerCss = ({ className, overrideCssClass, isOpen, alignByRightCorner, disabled, } = {}) => {
    const datePicker = [];
    const datePickerSelectionBox = [];
    const datePickerLabel = [];
    const datePickerSelectedDate = [];
    const datePickerIcon = [];
    const datePickerCalendar = [];
    if (!overrideCssClass) {
        datePicker.push('date-picker');
        datePickerSelectionBox.push('date-picker__selection-box');
        datePickerLabel.push('date-picker__label');
        datePickerSelectedDate.push('date-picker__selected-date');
        datePickerIcon.push('date-picker__icon');
        datePickerCalendar.push('date-picker__calendar');
        if (isOpen) {
            datePickerSelectionBox.push('date-picker__selection-box--opened');
        }
        if (alignByRightCorner) {
            datePickerCalendar.push('date-picker__calendar--align-left-corner');
        }
        if (disabled) {
            datePickerSelectedDate.push('date-picker__selected-date--disabled');
        }
    }
    if (className) {
        datePicker.push(`${className}`);
        datePickerSelectionBox.push(`${className}__selection-box`);
        datePickerLabel.push(`${className}__label`);
        datePickerSelectedDate.push(`${className}__selected-date`);
        datePickerIcon.push(`${className}__icon`);
        datePickerCalendar.push(`${className}__calendar`);
        if (isOpen) {
            datePickerSelectionBox.push(`${className}__selection-box--opened`);
        }
        if (alignByRightCorner) {
            datePickerCalendar.push(`${className}__calendar--align-left-corner`);
        }
        if (disabled) {
            datePickerSelectedDate.push(`${className}__selected-date--disabled`);
        }
    }
    return {
        datePicker: datePicker.join(' '),
        datePickerSelectionBox: datePickerSelectionBox.join(' '),
        datePickerLabel: datePickerLabel.join(' '),
        datePickerSelectedDate: datePickerSelectedDate.join(' '),
        datePickerIcon: datePickerIcon.join(' '),
        datePickerCalendar: datePickerCalendar.join(' '),
    };
};
//# sourceMappingURL=datePickerCss.js.map